const getCurrentMapsAPIInstance = () => {
    return typeof google === 'undefined' ? null : google.maps;
};
export default getCurrentMapsAPIInstance;
//# sourceMappingURL=getCurrentMapsAPIInstance.js.map